module.exports = __webpack_public_path__ + "static/email-template-trial-ended-esai-cf6f257e6584fdff163afb614244a665.png";